import { useMemo, ComponentProps, memo } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { Placement } from '@atlassian/post-office-placement-remote';
import { RemoteComponent } from '@atlassian/remote-module-loader/remote-component';
import Switcher from '@atlassian/switcher';

import { StatsigFeatureKeys } from 'src/features';

import { useRemoteSwitcherPlugin } from '../../utils/use-remote-switcher-plugin';

import { SwitcherContainer } from './atlassian-switcher.style';

type BaseSwitcherProps = {
  appearance: 'standalone' | 'drawer';
  tenantId?: string;
};

type SwitcherComponentProps = ComponentProps<typeof Switcher>;

export const BaseSwitcher = memo((props: BaseSwitcherProps) => {
  const { appearance } = props;

  const remoteSwitcherPlugin = useRemoteSwitcherPlugin();

  const isPostOfficeIntegrationEnabled = FeatureGates.checkGate(
    StatsigFeatureKeys.postOfficeIntegrationInAppSwitcher
  );

  const switcherProps = useMemo<SwitcherComponentProps>(
    () => ({
      appearance,
      product: 'bitbucket',
      disableCustomLinks: true,
      discoverySection: isPostOfficeIntegrationEnabled ? (
        <Placement placementId="app-switcher-discovery-section" />
      ) : undefined,
    }),
    [appearance, isPostOfficeIntegrationEnabled]
  );

  return (
    <SwitcherContainer data-testid="base-switcher">
      <RemoteComponent<SwitcherComponentProps>
        remotePlugin={remoteSwitcherPlugin}
        analyticsChannel="navigation"
        ErrorFallback={<Switcher {...switcherProps} />}
        {...switcherProps}
      />
    </SwitcherContainer>
  );
});
